import axios from 'axios';
import authHeader from "@/service/auth-header";

class GenericAvailabilityService {

    getAvailabilityByPractitioner(companyId, practitionerId) {
        console.log("[GenericAvailabilityService][getAvailabilityByPractitioner] Before getting practitioners. Company ID = ", companyId);
        return axios.get(`/api/genericavailability/${companyId}/practitioner/${practitionerId}`, {headers: authHeader()})
    }

    saveAvailabilityInBatch(companyId, practitionerId, data) {
        console.log("[GenericAvailabilityService][saveAvailabilityInBatch] Before creating practitioner back-end API call. Data = ", data);
        return axios.post(`/api/genericavailability/${companyId}/${practitionerId}/batch`, data, {headers: authHeader()});
    }

    getAvailableSlots(companyId, practitionerId) {
        console.log("[GenericAvailabilityService][getAvailableSlots] Before getting practitioners. Company ID = ", companyId);
        return axios.get(`/api/genericavailability/available-slots/${companyId}/practitioner/${practitionerId}`, {headers: authHeader()})
    }

    // searchCompanyPractitioners(companyId, searchCriteria) {
    //     console.log("[PractitionerService][getCompanyPractitioners] Before getting practitioners. Company ID = ", companyId);
    //     return axios.get(`/api/genericavailability/${companyId}/${searchCriteria}`, {headers: authHeader()})
    // }
    //
    // getPractitioner(practitionerId) {
    //     console.log("[PractitionerService][getCompanyPractitioners] Before getting practitioners. Practitioner ID = ", practitionerId);
    //     return axios.get(`/api/genericavailability/specific/${practitionerId}`, {headers: authHeader()})
    // }
    //
    // createPractitioner(companyId, data) {
    //     console.log("[PractitionerService][createPractitioner] Before creating practitioner back-end API call. Data = ", data);
    //     return axios.post(`/api/genericavailability/${companyId}`, data, {headers: authHeader()});
    // }
    //
    // updatePractitioner(practitionerId, data) {
    //     console.log("[PractitionerService][updatePractitioner] Before updating practitioner back-end API call. Data = ", data);
    //     return axios.put(`/api/genericavailability/${practitionerId}`, data, {headers: authHeader()});
    // }
    //
    // deletePractitioner(practitionerId) {
    //     console.log("[PractitionerService][deletePractitioner] Before deleting practitioner. Practitioner ID = ", practitionerId);
    //     return axios.delete(`/api/genericavailability/${practitionerId}`, {headers: authHeader()});
    // }

}

export default new GenericAvailabilityService();
